import { render, staticRenderFns } from "./InterviewInvitationDialog.vue?vue&type=template&id=2d8568d8&scoped=true"
import script from "./InterviewInvitationDialog.vue?vue&type=script&lang=js"
export * from "./InterviewInvitationDialog.vue?vue&type=script&lang=js"
import style0 from "./InterviewInvitationDialog.vue?vue&type=style&index=0&id=2d8568d8&prod&lang=scss&scoped=true"
import style1 from "./InterviewInvitationDialog.vue?vue&type=style&index=1&id=2d8568d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8568d8",
  null
  
)

export default component.exports